import css from "./style.module.css";
import React, { useEffect, useState } from "react";
const QNAPage = () => {
  const [problems, setProblems] = useState([]);

  useEffect(() => {
    fetch("/qna.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => setProblems(data))

      .catch((error) => console.error("Ошибка при загрузке данных:", error));
  }, []);

  // Состояние для отслеживания открытой карточки
  const [activeProblem, setActiveProblem] = useState(null);

  // Обработчик для переключения видимости текста
  const toggleSolution = (id) => {
    setActiveProblem(activeProblem === id ? null : id); // Скрыть, если уже открыто
  };

  return (
    <main className={css.root}>
      <div className="container">
        <div className={css["text"]}>
          <h1> {">"} Основные вопросы</h1>
          <h3>
            Здесь можно найти ответы на самые распространённые вопросы по работе
            с компьютером. <br /> Если ответа на вопрос вы не нашли, оформите
            заявку администратору
          </h3>
        </div>

        {problems.map((problem) => (
          <div
            key={problem.id}
            style={{
              background: "#2d3e50",
              color: "#fff",
              margin: "10px 0",
              borderRadius: "10px",
              padding: "15px",
            }}
            className={css["problem_item"]}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{problem.title}</span>
              <button
                onClick={() => toggleSolution(problem.id)}
                className={css["solution_button"]}
              >
                Решение
              </button>
            </div>
            {activeProblem === problem.id && (
              <div
                style={{
                  marginTop: "10px",
                  background: "#34495e",
                  padding: "10px",
                  borderRadius: "5px",
                }}
              >
                {problem.solution.split("\n").map((line, index) => (
                  <p key={index}>{line.trim()}</p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </main>
  );
};

export default QNAPage;

// У неопытных учителей могут возникать различные проблемы с компьютером в школе, особенно если они не имеют достаточного опыта работы с техникой или программным обеспечением. Вот некоторые из наиболее распространённых проблем:

// 1. Технические проблемы с компьютером
// Неисправности компьютера: Компьютер может не включаться, зависать, работать медленно или внезапно отключаться.
// Проблемы с периферией: Учителя могут столкнуться с проблемами подключения или работы мыши, клавиатуры, принтера, сканера или других внешних устройств.
// Проблемы с интернетом: Учителя могут не знать, как решить проблемы с Wi-Fi, сетевым подключением или доступом к интернету.
// Ошибки программного обеспечения: Приложения или операционная система могут выдавать ошибки или неправильно функционировать.
// 2. Проблемы с программным обеспечением
// Незнание программ: Учителя могут не знать, как пользоваться специализированными школьными программами (например, для ведения электронных журналов, систем тестирования).
// Проблемы с офисными программами: Проблемы с использованием Microsoft Word, Excel, PowerPoint или Google Docs (например, форматирование документов, создание таблиц, презентаций).
// Обновления программ: Неопытные пользователи могут испытывать трудности с установкой обновлений для операционной системы или приложений, что может привести к сбоям в работе.
// 3. Безопасность и конфиденциальность
// Проблемы с антивирусами: Учителя могут не знать, как проверить систему на наличие вирусов или работать с антивирусными программами.
// Фишинговые атаки и мошенничество: Незнание, как защититься от фишинга, и ошибки при работе с подозрительными письмами или сайтами.
// Работа с конфиденциальными данными: Ошибки при работе с паролями, файлами или документами, содержащими личную информацию учащихся, что может привести к утечке данных.
// 4. Проблемы с доступом и аккаунтами
// Забытые пароли: Учителя могут забывать пароли к школьным аккаунтам (например, для электронных журналов или почтовых систем).
// Неправильные настройки учетных записей: Проблемы с входом в системы из-за неверных настроек учетной записи или отсутствия доступа.
// 5. Программные настройки и пользовательский интерфейс
// Проблемы с настройками ОС: Учителям может быть сложно настроить параметры компьютера, такие как язык системы, дисплей, подключение к проекторам или настройка звука.
// Запутанный интерфейс: Современные интерфейсы могут быть сложными для учителей, не привыкших к работе с компьютерами. Сложности могут возникать при навигации по системе или поиске нужных программ.
// 6. Работа с мультимедиа
// Подключение к проекторам и интерактивным доскам: Учителя могут испытывать трудности с подключением к проекторам или работе с интерактивными досками, особенно если есть несовместимость устройств или проблемы с драйверами.
// Воспроизведение мультимедиа: Проблемы с открытием видео- или аудиофайлов, несовместимость форматов файлов или программ для их воспроизведения.
// 7. Программное обеспечение для удалённого обучения
// Проблемы с платформами для онлайн-обучения: Учителя могут испытывать трудности с использованием Zoom, Google Meet, Microsoft Teams, а также других систем для проведения дистанционных уроков.
// Проблемы с загрузкой и отправкой материалов: Ошибки при загрузке материалов для уроков, загрузке домашних заданий или использовании онлайн-тестирования.
// 8. Печать и сканирование
// Проблемы с принтерами: Учителя могут столкнуться с проблемами при подключении к принтеру, настройке печати или ее очереди. Часто проблемы возникают из-за нехватки бумаги, чернил или настройки форматов печати.
// Сканирование документов: Настройка и использование сканеров может вызвать затруднения, особенно если нужно сохранить документ в определенном формате.
// 9. Низкая скорость работы и загрузки
// Старые компьютеры: Школьные компьютеры могут быть устаревшими, что приводит к медленной работе, а учителя не всегда знают, как оптимизировать систему (например, закрывать ненужные программы).
// Проблемы с открытием крупных файлов: Учителя могут столкнуться с медленным открытием презентаций или документов большого размера.
// 10. Неоптимальная организация рабочего пространства
// Маленькие или неинтуитивные панели инструментов: Учителям может быть сложно найти необходимые функции в программах из-за сложных интерфейсов или неправильной настройки панели инструментов.
// Недостаток навыков в мультитаскинге: Учителя могут испытывать затруднения при переключении между разными окнами или задачами на компьютере.
